module.exports = __webpack_public_path__ + "img/Mondriaanfonds_logo.5540c508.png";